
export enum MedicalAnswerType {
	YN = 'YN', YWN = 'YWN', OPTIONS = 'OPTIONS'
}

export const AllergiesQuestionID = 'KcQQau4xrYa5ie3DfPMl';
export interface MedicalQuestion {
	questionId: string;
	question: string;
	typeAnswer: MedicalAnswerType;
	ywLabel?: string;
	options?: [];
}
